export default "__VITE_ASSET__bKBYg2Fy__"